module.exports = __webpack_public_path__ + "img/down1.f560b901.png";